import { PaletteMode, PaletteOptions } from '@mui/material';
import { GetThemeOptions } from '../theme';
import { unitySemanticDarkColorTokens, unitySemanticLightColorTokens } from '../unityTokens';
import { green, grey, INVALID_FALLBACK_COLOR } from './colors';
import { buildPaletteFromMetadata, type PaletteTokenMetadata, type Token } from './panw-palette/token-metadata';

const borderTokens = [
  { propertyPath: 'bold', tokenName: '--semantic-border-bold' },
  { propertyPath: 'emphasized', tokenName: '--semantic-border-emphasized' },
  { propertyPath: 'default', tokenName: '--semantic-border-default' },
  { propertyPath: 'disabled', tokenName: '--semantic-border-disabled' },
  { propertyPath: 'highlight', tokenName: '--semantic-border-highlight' },
  { propertyPath: 'subtle', tokenName: '--semantic-border-subtle' },
  { propertyPath: 'inverse', tokenName: '--semantic-border-inverse' },
  // we can replace border.separator with border.default once we flip the feature flag
  { propertyPath: 'separator', tokenName: '--semantic-border-default' },
] satisfies Token[];

export const borderTokenMetadata: PaletteTokenMetadata = {
  componentName: 'border',
  tokens: borderTokens,
};

export const border = (mode: PaletteMode, opts: GetThemeOptions): PaletteOptions['border'] => {
  if (opts.panwRebrandStubYear) {
    const tokens = mode === 'light' ? unitySemanticLightColorTokens : unitySemanticDarkColorTokens;
    return buildPaletteFromMetadata(borderTokens, tokens);
  }

  return mode === 'light'
    ? {
        bold: grey[300],
        emphasized: grey[150],
        default: grey[150],
        highlight: green[600],
        separator: '#0000001f',
        // not used unless panwRebrandStubYear is true, but we need to keep the key for backwards compatibility
        disabled: grey[150],
        subtle: grey[150],
        inverse: INVALID_FALLBACK_COLOR,
      }
    : {
        bold: grey[600],
        emphasized: grey[150],
        default: grey[850],
        highlight: green[500],
        separator: '#ffffff1f',
        // not used unless panwRebrandStubYear is true, but we need to keep the key for backwards compatibility
        disabled: grey[850],
        subtle: grey[850],
        inverse: INVALID_FALLBACK_COLOR,
      };
};
